<script>
	import { Link } from 'svelte-routing';
</script>

<div class="hero">
	<div class="glide" id="glide_1">
		<div class="glide__track" data-glide-el="track">
			<ul class="glide__slides">
				<li class="glide__slide">
					<div class="center">
						<div class="left">
							<h1>SURFACE <span style="color:orange">UP !</span></h1>
							<p>
								Ride with Style Unleash Your Skateboarding Potential at Our
								Premier Skate Shop
							</p>
							<Link to="/products" style="margin-top: 10px;" class="btn btn-1"
								>SHOP NOW</Link
							>
						</div>
						<div class="right">
							<img class="img1" src="/images/hero-slide-1.png" alt="" />
						</div>
					</div>
				</li>
				<li class="glide__slide">
					<div class="center">
						<div class="left">
							<span>New Inspiration 2020</span>
							<h1>THE PERFECT MATCH!</h1>
							<p>Trending from men's and women's style collection</p>
							<Link to="/products" class="btn btn-1">SHOP NOW</Link>
						</div>
						<div class="right">
							<img class="img2" src="/images/hero-slide-2.jpg" alt="" />
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</div>
